module.exports = __webpack_public_path__ + "../resources/img/ic_setting_button_lt.c8d14b59.svg";